import React, { useContext, useEffect, useRef, useState } from "react";
import "./Right_End_Toolbar.css";
import Gray_Btn from "../../../common_components/common_btn/gray_btn/Gray_Btn";
import Blue_White_Gradient_Btn from "../../../common_components/common_btn/blue_white_gradient_btn/Blue_White_Gradient_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import Buy_sell_Btns from "./buy_sell_btns/Buy_sell_Btns";
import { Context } from "../../../../utils/context";
import {
  GetAllBuyAndSellPending,
  GetAllBuyAndSellPendingUpdate,
  postBuyAndSell,
  postBuyAndSellPending,
} from "../../../../utils/apis/buy_and_sell/buy_and_sell";
import { useForm } from "react-hook-form";
import Successfull_Modal from "../../../common_components/common_modal/successfull_modal/Successfull_Modal";
import Deposit_Lottie from "../../../animation/deposit_lottie/Deposit_Lottie";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getData } from "../../../../utils/api";

const Right_End_Toolbar = ({
  onClose,
  latestAmount,
  price,
  companyId,
  companyName,
  setPrice,
  getGraphData,
  openSuccess,
  openSuccessClose,
  setShowModalMessage,
  isMobile,
}) => {
  const { buyOrSale, getuserData, userdata, signin, appSetUpData } = useContext(
    Context
  );

  const [appSetUp, setAppSetUp] = useState(false);

  const getAppsetUpData = async (id) => {
    const response = await getData(`/common/masters/app-setup`);

    await setAppSetUp(response?.data);
  };

  useEffect(() => {
    getAppsetUpData();
  }, []);

  useEffect(() => {
    setPrice(latestAmount);
  }, [latestAmount]);

  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const [activeBtn, setActiveBtn] = useState("Market");

  const [quantities, setQuantities] = useState({ Volume: 1 });

  const [tradeError, setTradeError] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const btn_data = [
    {
      btn_name: "Volume",
      descn1: "0.01 |",
      descn2: "Lots",
    },
    // Additional buttons like Take Profit or Stop Loss can be added here
  ];

  const handleIncrement = (id) => {
    setQuantities((prev) => ({ ...prev, [id]: (prev[id] || 0) + 1 }));
  };

  const handleDecrement = (id) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: Math.max((prev[id] || 0) - 1, 1),
    }));
  };

  const handleSend = (id) => {
    const quantity = quantities[id] || 0;
    // Placeholder for future logic or API call
  };

  const [targetPrice, setTargetPrice] = useState("");
  const [allPendingtrade, setAllPendingTrade] = useState([]);
  

  const getPending = async () => {
    const res = await GetAllBuyAndSellPending(companyId);
    if (res?.success) {
      setAllPendingTrade(res.data);
    }
  };

  useEffect(() => {
    if (signin) {
      getPending();
    }
  }, []);

  const submit = async () => {
    if (!buyOrSale) {
      setTradeError("Please select either Buy or Sell.");
      return;
    }

    const now = new Date();
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();

    const isBeforeMarketOpen =
      currentHours < 9 || (currentHours === 9 && currentMinutes < 30);
    const isAfterMarketClose =
      currentHours > 20 || (currentHours === 20 && currentMinutes > 30);

    // if (isBeforeMarketOpen || isAfterMarketClose) {
    //   setError("amount", {
    //     message: "Trading is available from 9:30 AM to 3:30 PM only.",
    //   });
    //   setTradeError(
    //     "Trading has been stopped. Please try again during market hours."
    //   );
    //   return;
    // }

    const quantity = quantities["Volume"] || 1;
    const payload = {
      amount: Number(price) * quantity,
      company_id: companyId,
      quantity: quantity,
      type: buyOrSale,
    };

    try {
      // setIsLoading(true); // start loader
      const res = await postBuyAndSell(payload);

      if (res?.success) {
        getGraphData();
        if (isMobile) {
          toast.success(`Successfully ${buyOrSale == "buy" ? "Buy" : "Sell"}`);
          setTimeout(() => {
            onClose();
          }, 3000);
        }
        setTradeError("");
        openSuccess();
        // setShowModal(true);
        setQuantities((prev) => ({ ...prev, Volume: 1 }));
        getuserData(userdata?.id);
        setTimeout(() => {
          // setIsLoading(false);
          openSuccessClose();
          // setShowModal(false);
        }, 3000);
      } else {
        setError("amount", { message: res?.message || "Transaction failed" });
        setTradeError(res?.message);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("amount", { message: "An error occurred. Please try again." });
      setIsLoading(false);
    }
  };

  const submitPending = async () => {
    if (!buyOrSale) {
      setTradeError("Please select either Buy or Sell.");
      return;
    }

    if (!targetPrice || isNaN(targetPrice) || Number(targetPrice) <= 0) {
      setError("amount", {
        message: "Target price is required and must be greater than 0.",
      });
      setTradeError("Please enter a valid target price.");
      return;
    }

    const now = new Date();
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();

    const quantity = quantities["Volume"] || 1;
    const payload = {
      amount:
        Number(targetPrice) * quantity + appSetUpData?.platform_percent / 100,
      company_id: companyId,
      quantity: quantity,
      type: buyOrSale,
    };

    try {
      const res = await postBuyAndSellPending(payload);

      if (res?.success) {
        getGraphData();
        if (isMobile) {
          toast.success(`Successfully ${buyOrSale == "buy" ? "Buy" : "Sell"}`);
          setTimeout(() => {
            onClose();
          }, 3000);
        }
        await getPending();
        await setTradeError("");
        await setTargetPrice("");
        await openSuccess();
        await setQuantities((prev) => ({ ...prev, Volume: 1 }));
        await getuserData(userdata?.id);
        await setTimeout(() => {
          openSuccessClose();
        }, 3000);
      } else {
        await setError("amount", {
          message: res?.message || "Transaction failed",
        });
        await setTradeError(res?.message);
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("amount", { message: "An error occurred. Please try again." });
    }
  };

  const submitPendingUpdate = async (matchedAmount) => {
    const now = new Date();
    const currentHours = now.getHours();
    const currentMinutes = now.getMinutes();
    const currentDay = now.getDay(); // 0 = Sunday, 6 = Saturday

    const quantity = quantities["Volume"] || 1;

    const payload = {
      amount: Number(matchedAmount),
      company_id: companyId,
      quantity: quantity,
      type: buyOrSale,
    };

    try {
      const res = await GetAllBuyAndSellPendingUpdate(payload);

      if (res?.success) {
        getGraphData();
        if (isMobile) {
          toast.success(`Successfully ${buyOrSale == "buy" ? "Buy" : "Sell"}`);
          setTimeout(() => {
            onClose();
          }, 3000);
        }
        await getPending();
        await setTargetPrice("");
        openSuccess();
        await setQuantities((prev) => ({ ...prev, Volume: 1 }));
        await getuserData(userdata?.id);
        await setTimeout(() => {
          openSuccessClose();
        }, 2000);
      } else {
        await setError("amount", {
          message: res?.message || "Transaction failed",
        });
        await setTradeError(res?.message);
      }
    } catch (error) {
      console.error("API Error:", error);
      setError("amount", { message: "An error occurred. Please try again." });
    }
  };

  const [hasTriggeredUpdate, setHasTriggeredUpdate] = useState(false);
  const updateTriggeredRef = useRef(false);

  console.log(latestAmount, "latestAmount");
  console.log(allPendingtrade, "allPendingtrade");

  useEffect(() => {
    if (!allPendingtrade?.length || !latestAmount) return;

    const match = allPendingtrade.find((trade) => {
      if (trade.amount == null || trade.quantity == null) return false;

      const tradePrice = Number(
        (Number(trade.amount) / Number(trade.quantity)).toFixed(2)
      );

      const diff = Math.abs(tradePrice - Number(latestAmount));

      return diff <= 0.4;
    });

    if (match) {
      updateTriggeredRef.current = true;
      submitPendingUpdate(match.amount);
    }
  }, [allPendingtrade, latestAmount]);

  useEffect(() => {
    setHasTriggeredUpdate(false);
  }, [latestAmount]);

  const sellOnClick = () => {
    setTradeError("");
    setTargetPrice("");
  };
  const buyOnClick = () => {
    setTargetPrice("");
    setTradeError("");
  };

  return (
    <section className="Right_End_Toolbar Instruments">
      {/* Header */}
      <div className="heading_part">
        {/* <p className="heading_name">XAU/USD</p> */}
        <b>
          <p className="heading_name">{companyName}</p>
        </b>

        {isMobile && (
          <div className="img_holder" onClick={onClose}>
            <img
              src="/assets/images/trade/close2.png"
              className="close_img"
              alt="Close"
            />
          </div>
        )}
      </div>

      <div className="regular_form_div">
        <Gray_Btn btn_name="Regular Form" />
      </div>

      {/* Buy/Sell Toggle Buttons */}
      <div className="buy_sell_btn_div">
        <Buy_sell_Btns
          latestAmount={latestAmount}
          setPrice={setPrice}
          price={price}
          sellOnClick={sellOnClick}
          BuyOnClick={buyOnClick}
        />
      </div>

      {/* Market/Pending Buttons */}
      <div className="market_pending_main_div">
        <div className="btns_holder">
          {["Market"].map((type) => (
            <div
              key={type}
              className={`market_btn ${activeBtn === type ? "active" : ""}`}
            >
              <Blue_White_Gradient_Btn
                btn_name={type}
                onClick={() => setActiveBtn(type)}
              />
            </div>
          ))}
        </div>{" "}
        <div className="btns_holder">
          {["Pending"].map((type) => (
            <div
              key={type}
              className={`market_btn ${activeBtn === type ? "active" : ""}`}
            >
              <Blue_White_Gradient_Btn
                btn_name={type}
                onClick={() => setActiveBtn(type)}
              />
            </div>
          ))}
        </div>
      </div>

      {activeBtn === "Pending" && (
        <div className="increament_btn_div">
          {/* <div className="btn_title22">Open Price</div> */}
          <input
            type="number"
            min="0"
            className="target_price_input form-control mt-2"
            placeholder={`${
              buyOrSale === "buy"
                ? "Enter Execution Price"
                : "Enter Execution Price"
            }`}
            value={targetPrice}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "" || parseFloat(value) >= 0) {
                setTargetPrice(value);
              }
            }}
          />
        </div>
      )}

      <div className="all_increments_btns">
        {btn_data.map((item) => (
          <div className="increament_btn_div" key={item.btn_name}>
            <div className="btn_title">{item.btn_name}</div>
            <div className="inner_data">
              <div
                className="plus_icon_div"
                onClick={() => handleDecrement(item.btn_name)}
              >
                <FontAwesomeIcon icon={faMinus} className="inner_icon" />
              </div>
              <input
                type="text"
                value={quantities[item.btn_name] || ""}
                onChange={(e) => {
                  const val = e.target.value;

                  // allow: empty OR positive numbers starting from 1 (no zero)
                  if (/^[1-9]\d*$/.test(val) || val === "") {
                    setQuantities((prev) => ({
                      ...prev,
                      [item.btn_name]: val,
                    }));
                  }
                }}
              />

              <div
                className="plus_icon_div"
                onClick={() => handleIncrement(item.btn_name)}
              >
                <FontAwesomeIcon icon={faPlus} className="inner_icon" />
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* <p className="warning_text">
        On Buy And Sell of trade {appSetUp?.platform_percent} % of platform
        percent will be applied{" "}
      </p> */}

      {/* Confirm/Cancel Buttons */}
      <div className="confirm_buy_btn">
        <div className="gray_btn">
          <Gray_Btn
            btn_name="Cancel Buy"
            onClick={() => {
              // navigate("/my-account")
              // onClose();
            }}
          />
        </div>
        <div
          className={`gray_btn ${
            buyOrSale === "buy" ? "active_green" : "active_red"
          } ${isLoading ? "pointer-events-none opacity-50" : ""}`}
        >
          <Gray_Btn
            btn_name={
              isLoading
                ? "Processing..."
                : buyOrSale === "buy"
                ? "Confirm Buy"
                : "Confirm Sell"
            }
            onClick={() => {
              if (isLoading) return;

              if (activeBtn === "Market") {
                if (signin) {
                  submit();
                } else {
                  navigate("/login");
                }
              } else {
                if (signin) {
                  submitPending();
                } else {
                  navigate("/login");
                }
              }
            }}
          />
        </div>
      </div>

      {/* Footer Info */}
      <div className="footer_text_holder">
        <div className="text_holder">
          <p className="label_text">Amount Record:</p>
          <p className="label_text">
            {(
              (quantities["Volume"] || 1) *
              (activeBtn === "Pending"
                ? parseFloat(targetPrice || price || 0)
                : parseFloat(price || 0))
            ).toFixed(2)}{" "}
            $
          </p>
        </div>
        <div className="text_holder">
          <p className="label_text">
            Fees ({appSetUpData?.platform_percent}%):
          </p>
          <p className="label_text">
            {(
              (Number(quantities["Volume"]) || 1) *
              (activeBtn === "Pending"
                ? parseFloat(targetPrice) || parseFloat(price) || 0
                : parseFloat(price) || 0) *
              ((Number(appSetUpData?.platform_percent) || 0) / 100)
            ).toFixed(2)}{" "}
            $
          </p>
        </div>
        <div className="text_holder">
          <p className="label_text">Amount Required:</p>
          <p className="label_text">
            {(
              (Number(quantities["Volume"]) || 1) *
              (activeBtn === "Pending"
                ? parseFloat(targetPrice) || parseFloat(price) || 0
                : parseFloat(price) || 0) *
              (1 + (Number(appSetUpData?.platform_percent) || 0) / 100)
            ).toFixed(2)}{" "}
            $
          </p>
        </div>
      </div>

      <div style={{ color: "red" }}>{tradeError}</div>

      {/* <p className="view_more_text">View More</p> */}
      <Successfull_Modal
        message={`Trade Successful! ${buyOrSale}`}
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
        lottie={<Deposit_Lottie />}
      />

      <ToastContainer autoClose={3000} />
    </section>
  );
};

export default Right_End_Toolbar;
